<template>
  <div class="handle">
    <keep-alive>
      <image-modal
        v-if="showModal"
        @close="showModal = false"
        @set-image="setImage"
        @set-image-link="setImageLink"
        :accentColor="color"
        :model="model"
        :step="step"
      ></image-modal>
    </keep-alive>

    <div
      ref="menu"
      class="tippy-holder flex flex-row justify-center items-center"
    >
      <div
        class="bubble-menu bg-white rounded-lg pl-1 pr-3 mb-1 shadow-lg flex flex-row justify-center"
      >
        <button
          class="menu flex flex-col items-center justify-center"
          v-tooltip="'Change Image'"
        >
          <span
            class="material-icons"
            @click="
              closeMenu();
              openModal();
            "
          >
            image
          </span>
        </button>

        <input
          class="w-9 h-9 border border-solid border-gray-200 text-center m-auto rounded"
          :value="width"
          @change="width = $event.target.value"
          v-tooltip="'Image width'"
        />

        <!-- Color Picker start -->
        <BasePopover :showPopover="colorSettings">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative"
              style="padding:0px"
              v-tooltip="'Fill Color'"
              @click="colorSettings = true"
              :style="{
                'box-shadow': 'none',
              }"
            >
              <span class="material-icons" :style="{ color: color }">
                palette
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class=" bg-gray-800 rounded mt-2 z-10 inline-block text-left pl-3 pb-3 pt-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse justify-between">
                <div @click="colorSettings = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold my-auto mr-2 cursor-pointer"
                  />
                </div>

                <div class="flex flex-row mb-1">
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="checked"
                    class="my-auto"
                  />
                  <label for="checkbox" class="text-xs text-white my-auto">
                    Use theme default
                  </label>
                </div>

              </div>

              <div class="pr-3">
                <verte
                  model="rgb"
                  v-model="color"
                  display="widget"
                  :enableAlpha="false"
                  :showHistory="false"
                >
                  <div
                    class="h-5 w-5 border border-solid border-white ml-2"
                    :style="{ background: color }"
                  ></div>
                </verte>
              </div>
            </div>
          </template>
        </BasePopover>

        <!-- Start Link Settings -->

        <BasePopover :showPopover="linkSettings" :placement="'bottom-end'">
          <template v-slot:button>
            <button
              class="menu"
              @click="linkSettings = true"
              v-tooltip="'Link'"
            >
              <span class="material-icons">
                open_in_new
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-link"
              class="rounded-lg mt-3 z-10 bg-white border border-solid border-gray-300 inline-block text-left px-3 pb-3 shadow"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse">
                <div @click="linkSettings = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-500 font-bold mt-2 -mr-1 cursor-pointer "
                  />
                </div>
              </div>

              <div class="pr-3">
                <label
                  for="goto"
                  class="block text-sm font-medium pb-2 text-gray-500"
                  >When the image is clicked go to:
                </label>
                <select
                  v-model="goto"
                  id="goto"
                  name="goto"
                  autocomplete="goto"
                  class="mt-1 block w-full py-2 px-3 bg-gray-100 focus:bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                >
                  <option value="next">The next step </option>
                  <option value="prev">The previous step</option>
                  <option
                    :key="index"
                    v-for="(item, index) in survey.steps"
                    :value="item.id"
                  >
                    <span class="font-bold">Step {{ index + 1 }}: </span
                    >{{ item.title }}
                  </option>
                  <option value="link">An External link </option>
                  <option value="close">Close page and exit flow </option>
                </select>
              </div>

              <div v-show="goto == 'link'" class="col-span-3 sm:col-span-2">
                <label class="block text-sm font-medium text-gray-700 mt-3">
                  Link:
                </label>
                <div class="mt-1 flex rounded-md shadow-sm">
                  <input
                    type="text"
                    class="py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-md sm:text-sm border border-solid border-gray-300"
                    placeholder="http://www.example.com"
                    v-model="gotoLink"
                  />
                </div>
              </div>
            </div>
          </template>
        </BasePopover>

        <button class="menu" v-tooltip="'Clone Image'" @click="copyContent">
          <span class="material-icons">
            content_copy
          </span>
        </button>
      </div>

      <div class="outer__menu flex flex-row">
        <div @click="closeMenu" v-tooltip="'Close Menu'">
          <svg-icon
            icon="heroicons/outline/x"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
          />
        </div>

        <div @click="$emit('delete-content', model)">
          <svg-icon
            icon="heroicons/outline/trash"
            class="h-8 w-8 cursor-pointer p-1 text-gray-500 bg-gray-200 hover:bg-gray-300 rounded-full ml-2"
            v-tooltip="'Delete image'"
          />
        </div>
      </div>
    </div>

    <div
      ref="image"
      class="display-block mx-auto cursor-pointer rounded flex flex-col justify-center"
    >
      <img
        v-if="model.image == 'link'"
        :src="model.image_link"
        class="display-block mx-auto hover:bg-gray-100 cursor-pointer rounded max-w-full max-h-full"
        :style="{ width: width + 'px' }"
      />

      <svg-inline
        v-else
        class="h-full"
        :style="{ color: color, width: width + 'px' }"
        :image="model.image"
      />
    </div>
  </div>
</template>

<script>
import Image from "@/models/content/Image";
import tippy from "tippy.js";
//Verte Color Picker
//https://baianat.github.io/verte/guide/
import Verte from "verte";

export default {
  components: {
    Verte,
    ImageModal: () =>
      import(/* webpackPrefetch: true */ "@/components/Builder/ImageModal.vue"),
  },
  data() {
    return {
      showModal: false,
      showSettings: false,
      colorSettings: false,
      showContentPopover: false,
      bubbleMenu: null,
      linkSettings: false,
      checked: false,
      disabled: null,
    };
  },
  props: ["content_id", "survey", "step", "align"],
  computed: {
    model() {
      return Image.find(this.content_id);
    },
    width: {
      get() {
        return this.model.width;
      },
      set(num) {
        if (isNaN(num)) num = null;
        Image.update({
          where: this.content_id,
          data: { width: num },
        });
      },
    },

    /*
    checked: {
      get() {
        return (this.bgColor == null ) ? true : false;
      },
      set(value) {

        if (value == true) {
          //this.color = this.survey.accentColor;
          this.bgColor = null;
        }

      },
    },
    */

    bgColor: {
      get() {
        return this.model.bgColor;
      },
      set(value) {
        Image.update({
          where: this.model.id,
          data: { bgColor: value },
        });
      },
    },

    color: {
      get() {
        return this.model.bgColor ?? this.survey.accentColor;
      },
      set(value) {
        if (!this.checked) {
          this.bgColor = value;
          //Image.update({ where: this.model.id, data: { bgColor: value } });
        }
      },
    },
    goto: {
      get() {
        return this.model.goto;
      },
      set(value) {
        if (value !== this.model.goto) {
          Image.update({ where: this.model.id, data: { goto: value } });
        }
      },
    },
    gotoLink: {
      get() {
        return this.model.goto_link;
      },
      set(value) {
        if (value !== this.model.goto_link) {
          Image.update({ where: this.model.id, data: { goto_link: value } });
        }
      },
    },
  },
  methods: {
    checkMe(value) {
      //console.log("val: " + value);
      if (value) {
        this.color = this.survey.accentColor;
        Image.update({ where: this.model.id, data: { bgColor: null } });
      }
    },
    closeModal: function() {
      this.showModal = false;
      window.removeEventListener("keydown", this.onEscape);
    },
    openModal: function() {
      this.showModal = true;
      window.addEventListener("keydown", this.onEscape);
    },
    onEscape: function(e) {
      if (this.showModal && e.keyCode === 27) {
        this.closeModal();
      }
    },
    setAlign(dir) {
      this.$emit("set-align", dir);
    },
    setImage(value) {
      Image.update({ where: this.model.id, data: { image: value } });
    },
    setImageLink(value) {
      console.log("setting image link: " + value);
      Image.update({
        where: this.model.id,
        data: { image_link: value, image: "link" },
      });
    },
    copyContent() {
      this.$emit("copy-content", this.model);
    },
    closeMenu() {
      //Close BubbleMenu created by Tippy.js directly (w/o editor)
      this.bubbleMenu.hide();
    },
    debounceClick: function(func) {
      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        func();
      }, 200); // delay
    },
  },

  watch: {
    checked() {
      if (this.checked == true) this.bgColor = null;
    },
    /*
    bgColor(){
        if (this.bgColor == null) this.checked = true;
    }*/
  },

  mounted() {
    if (this.bgColor == null) this.checked = true;

    let target = this.$refs.image;
    let menu = this.$refs.menu;

    this.bubbleMenu = tippy(target, {
      content: menu,
      interactive: true,
      duration: 10,
      maxWidth: "none",
      hideOnClick: false,
      trigger: "click",
      onClickOutside(instance, event) {
        instance.hide();
      },
    });
  },

  destroyed() {
    window.removeEventListener("keydown", this.onEscape);
  },
};
</script>

<style></style>
